import { Model } from "../clients/subscription/subscription.model";
import { intYYYYMMToString } from "../library/utils";
import { ContractDocumentModel } from "./contract/contract.model";

export class ClientContractModel extends Model {
    public companyName: string;
    public isVatPayer: boolean;
    public contractDocumentEid: string;
    public contractDocument: ContractDocumentModel;

    get hasDocuments() {
        if (this.data.currentContract && this.data.currentContract.contract) {
            return this.data.currentContract.contract.docsNumIncluded > 0;
        }
        return false;
    }

    get hasEmployees() {
        if (this.data.currentContract && this.data.currentContract.contract) {
            return this.data.currentContract.contract.empsNumIncluded > 0;
        }
        return false;
    }

    get hasImports() {
        if (this.data.currentContract && this.data.currentContract.contract) {
            return this.data.currentContract.contract.impsNumIncluded > 0;
        }
        return false;
    }

    get prevMonthAsString() {
        return intYYYYMMToString(this.prevMonth, 'ro-ro');
    }

    get isTerminatedContract() {
        return this.data && this.data.clientChangeRequestProcessStatusRepresentation &&
            (this.data.clientChangeRequestProcessStatusRepresentation.cancellationProcess !== null ||
            this.data.clientChangeRequestProcessStatusRepresentation.dissolutionProcess !== null)
    }
}

export class SubscriptionBadgesModel {
    public hasExtraCost: boolean;
    public extraCostAmount: number;
    public hasUnpaidInvoice: boolean;
    public unpaidInvoiceAmount: number;
}